export default "__VITE_ASSET__CFKmoUfS__"